import React from "react";
import { ReactComponent as EmmptyRealEstate } from "../../assets/images/svg/emptyRealEstate.svg";

const EmptyRealEstate = () => {
  return (
    <div className="empty_real_estate_outside">
      <div className="empty_real_estate_main">
        <EmmptyRealEstate style={{ marginTop: "177px" }} />

        <h2 className="empty_real_estate_comment">
          To track your real estate assets, get in touch with your Relationship
          Manager
        </h2>
      </div>
    </div>
  );
};

export default EmptyRealEstate;
